module.exports = __webpack_public_path__ + "static/media/Oceans-Badges.c15eab60.jpg";